module.exports = __webpack_public_path__ + "media/images/sandbox/product_header_perfectbind-624b63e3707fb1514829da3f1e855908.jpg";